// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3QJM7","subheader":"ReorderModal_subheader__2Apa9","listWrap":"ReorderModal_listWrap__2PHQr"};